/* @flow */

import { MOEDA } from './constants';

const removerFormatacaoDinheiro = (
    s: string,
): number => Number(s.replace(/\./g, '').replace(/,/, '.').replace(MOEDA, ''));

export default removerFormatacaoDinheiro;
